import RequestPayload from "slotworks/model/gameplay/requests/request-payload";

export default class GambleInitRequestPayload extends RequestPayload {
    public gambleID: number;
    public stake: number;
}
